import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, NavigationExtras, UrlTree } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class CanActivateSubstanceForm implements CanActivate {

    constructor(
        private router: Router,
        private authService: AuthService
    ) { }

    async canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean | UrlTree> {
        const auth = this.authService.getAuth();
        if (auth) {
            const canEdit =await this.authService.hasSpecificPrivilege('Edit');
            if(canEdit){
                return true;
            }else {
                return this.router.parseUrl('/browse-substance');
            }
        } else {
            const navigationExtras: NavigationExtras = {
                queryParams: {
                    path: state.url
                }
            };
            return this.router.createUrlTree(['/login'], navigationExtras);
        }
    }
}
